import { useMutation } from '@tanstack/react-query';

/* Apis */
import { user } from '@api/apis';

/* Utils / Constants */
import { StatusErrors } from '@constants/base';
import { deriveResponseStatus } from '@utils/object';
import { Logger } from '@utils/logger';

/**
 * We have two apps, and setting of the http cookie has issues across the apps.
 * So, we call the "current" on the server side, get the cookie and set it.
 * But to do so, we need to pass along the auth-token.
 *
 * @param {IHash<any> | undefined} options
 * @returns {UseQueryResult<any, unknown>}
 */
const useUserMutationCheckUserEmail = () => {
  /* merge default options with passed in options */
  const mergedOptions = {};

  return useMutation({
    mutationFn: async ({ email }: { email: string }) => {
      const response = await user.checkUserEmail({ email });

      if (StatusErrors.has(deriveResponseStatus(response)) || response.err) throw response;

      return { ...response.data, email };
    },
    /* We should move this out to the global config and log there */
    onError: error => {
      Logger('Validate Email')(error as Error);
    },
    ...mergedOptions,
  });
};

export default useUserMutationCheckUserEmail;
